import React from 'react';
import { useDispatch } from 'react-redux';

import { ForgeIcon, ForgeTooltip } from '@tylertech/forge-react';
import { I18n } from 'common/i18n';

import { EnvironmentFactory } from 'StorytellerEnvironment';
import { deleteBlockComponent } from 'store/reducers/StoryReducer';

import './index.scss';

/**
 * Renders a dragger bar over flexible layout components.
 * Also a delete button, since only flex can delete individual components.
 */
export const ComponentDraggerControl = ({
  blockId,
  componentIndex,
}: {
  blockId: string;
  componentIndex: number;
}) => {
  const dispatch = useDispatch();
  const storyUid = EnvironmentFactory().STORY_UID;

  const onRemove = (): void => {
    dispatch(deleteBlockComponent({ storyUid, blockId, componentIndex: componentIndex }));
  };

  return (
    <div className="component-dragger-container component-base">
      <div className="component-dragger-bar">
        <ForgeIcon
          name="delete"
          id={`component-remove-${componentIndex}`}
          className="component-remove"
          onClick={onRemove}
          aria-label={I18n.t('shared.components.filter_bar.remove')}
          role="button"
        />
        <ForgeTooltip
          anchor={`component-remove-${componentIndex}`}
          text={I18n.t('shared.components.filter_bar.remove')}
          placement={'right'}
        />
        <ForgeIcon className="component-dragger grab-handle" name="drag_indicator" aria-hidden />
      </div>
    </div>
  );
};
